import { render, staticRenderFns } from "./PromoTable.vue?vue&type=template&id=6de1b088"
import script from "./PromoTable.vue?vue&type=script&lang=js"
export * from "./PromoTable.vue?vue&type=script&lang=js"
import style0 from "./PromoTable.vue?vue&type=style&index=0&id=6de1b088&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports